/* src/app/core/components/navbar-mobile/navbar-mobile.component.scss */
:host {
  display: block;
  position: fixed;
  height: 70px;
  background: #ffffff;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  border-top: 1px solid #ccc;
}
@media (min-width: 768px) {
  :host {
    display: none;
  }
}
.navbar-mobile {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  list-style-type: none;
  padding: 0;
}
.navbar-mobile__item {
  width: 25%;
  height: 70px;
}
.navbar-mobile__item a {
  width: 100%;
  height: 70px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
}
/*# sourceMappingURL=navbar-mobile.component.css.map */
